import { StyleSymbolType, ParameterByAttributeValue } from "@evergis/react";
import { ParameterDcColor, DashedBrushDc, SolidStrokeBrushDc } from "@evergis/api";

import { isClusterSymbol, isH3GridSymbol, isPolygonSymbol } from "../../../interfaces/style";

export function getGradientColors(
  symbol: StyleSymbolType | DashedBrushDc | SolidStrokeBrushDc,
  prop: "fill" | "stroke" = "fill",
): string[] {
  let color;

  if ((symbol as DashedBrushDc | SolidStrokeBrushDc).color) {
    color = (symbol as DashedBrushDc | SolidStrokeBrushDc).color as ParameterDcColor & {
      values: ParameterByAttributeValue<string>[];
    };
  }

  if (isPolygonSymbol(symbol) || isH3GridSymbol(symbol)) {
    color = symbol[prop]?.color as ParameterDcColor & { values: ParameterByAttributeValue<string>[] };
  }

  if (isClusterSymbol(symbol)) {
    color = symbol[`${prop}Color`] as ParameterDcColor & { values: ParameterByAttributeValue<string>[] };
  }

  return color?.values?.length ? color.values?.map(({ value }) => value) : [];
}
